import { Component } from '@angular/core';
import { FormControl } from '@angular/forms';
import {
  AppLanguage,
  LanguageService,
} from 'src/app/services/language.service';
import { TranslateService } from '@ngx-translate/core';
import { take } from 'rxjs';
import { StorageKeys, StorageService } from 'src/app/services/storage.service';
import { FullscreenModalService } from 'src/app/services/fullscreen-modal.service';
import { NavController } from '@ionic/angular';
import { ModalService } from 'src/app/services/modal.service';
import { AuthService } from 'src/app/auth/auth.service';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss'],
})
export class SettingsComponent {

  constructor(
    private readonly languageService: LanguageService,
    private readonly translationService: TranslateService,
    private readonly storageService: StorageService,
    private readonly navCtrl: NavController,
    private readonly modalService: ModalService,
    private readonly authService: AuthService
  ) {}

  onOpenAboutScreen(): void {
    this.navCtrl.navigateForward('about');
  }

  onDeleteProfileClick(): void {
    this.modalService.showDeleteProfileModal().subscribe((isDeleted) => {
      if (isDeleted) {
        this.authService.logout().subscribe();
      }
    });
  }
}
